import { WithTheme } from '@issuemanager/apps/client/theme';
import { AlertColor, Box, Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/system';
import React, { ReactNode } from 'react';
import { DismissButton, MultipleButtons } from '../buttons';
import { StyledAlert } from './alert';

const StyledErrorTitle = styled(Typography)<WithTheme<TypographyProps>>(
  ({ theme }) => ({
    fontSize: theme.tokens.semantic.fontSize.text.body.value,
    fontWeight: 400,
    color: theme.tokens.semantic.color.status.error.value,
    marginBottom: 0,
  }),
);

const StyledErrorSubtitle = styled(Typography)<WithTheme<TypographyProps>>(
  ({ theme }) => ({
    fontSize: theme.tokens.semantic.fontSize.text.body.value,
    fontWeight: 400,
    color: theme.tokens.semantic.color.text.body.value,
    marginTop: '4px',
    marginBottom: '8px',
  }),
);

type SideToastWithCategoriesProps = {
  title: string;
  subtitle?: string;
  issueTypes: { name: string; child: ReactNode }[];
  type?: AlertColor;
  action?: 'compact' | 'divided';
  onClose?: () => void;
  onAction?: () => void;
};

function SideToastWithCategories({
  type,
  title,
  subtitle,
  issueTypes,
  action = 'compact',
  onClose = () => null,
  onAction = () => null,
}: SideToastWithCategoriesProps): React.JSX.Element {
  const actionElement =
    action === 'compact' ? (
      <DismissButton onClose={onClose} />
    ) : (
      <MultipleButtons onClose={onClose} onAction={onAction} />
    );
  return (
    <StyledAlert severity={type} action={actionElement} variant='standard'>
      <Box display='flex' flexDirection='column'>
        <StyledErrorTitle>{title}</StyledErrorTitle>
        {subtitle && <StyledErrorSubtitle>{subtitle}</StyledErrorSubtitle>}
        {issueTypes.map((issueType) => (
          <Box key={issueType.name || 'default'} mt={0}>
            <Box flexDirection='column'>{issueType.child}</Box>
          </Box>
        ))}
      </Box>
    </StyledAlert>
  );
}

export default SideToastWithCategories;
